import { inject, Injectable, signal } from '@angular/core';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';
import {
  ColumnPreference,
  ColumnsModelApiResponse,
  SearchColumnResults,
  StandardAddress,
} from '@models/ColumnsModel';
import { Obj } from '@popperjs/core';
import { SourceCrossReference } from '@models/CrossReference';
import { SourceData } from '@models/SourceData';
import { SourceApiResponse } from '@models/Source';
import { SearchHistoryResponse } from '@models/SearchHistory';
import { ExportDateResponse } from '@models/ExportExipreDate';
import { BulkSearchResponse } from '@models/BulkSearch';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class SearchProfileService {
  private httpService = inject(HttpService);
  crMandatoryCols: string[] = ['rcm_id', 'source', 'source_id'];
  gpMandatoryCols: string[] = ['rcm_id', 'name'];
  gpColPref = signal('');
  crColPref = signal('');
  getSearchProfile(params: Obj): Observable<SearchColumnResults> {
    return this.httpService.post('search', params);
  }
  getColumnBasedSearchProfile(params: Obj): Observable<SourceCrossReference> {
    return this.httpService.post('columnBasedSearch', params);
  }

  getSources(): Observable<SourceApiResponse> {
    return this.httpService.get('typesource');
  }

  getExpireDate(params: Obj): Observable<SourceData> {
    return this.httpService.post('expirationDate', params);
  }

  getStandardAddress(params: Obj): Observable<StandardAddress> {
    return this.httpService.post('standardAddress', params);
  }

  getColumns(): Observable<ColumnsModelApiResponse> {
    return this.httpService.get('columnNames');
  }

  saveUserColumnPreference(params: Obj): Observable<ColumnPreference> {
    return this.httpService.post('userPreferredColumns', params);
  }

  getUserColumnPreference(): Observable<ColumnPreference> {
    return this.httpService.get('getUserColumns');
  }
   getUserSearchHistory(): Observable<SearchHistoryResponse> {
    return this.httpService.get('searchHistory');
  }
   getExportExpirationDate(params:object): Observable<ExportDateResponse> {
    return this.httpService.post('exportExpirationDate',params);
  }
  getBulkSearch(params:object): Observable<BulkSearchResponse> {
    return this.httpService.post('bulkSearch',params);
  }
  getBulkSearchStream(params: object): Observable<MessageEvent> {
    const opt={
      headers: new HttpHeaders(),
      reportProgress: true,
      observe: 'events' // or 'response', 'events'
    }
    return this.httpService.post('bulkSearch/stream', params,opt);
  }
}
